import { memo, useEffect, useState } from 'react'
import classNames from 'classnames'
import { SvgIcon } from 'ui_kit_qmd'
import './Pagination.scss'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const getPaginationScore = (leftCount, rightCount, totalCount) => {
  if (totalCount === 1) {
    return `${totalCount} of ${totalCount}`
  }

  if (rightCount >= totalCount) {
    return `${leftCount + 1}-${totalCount} of ${totalCount}`
  }

  return `${leftCount + 1}-${rightCount} of ${totalCount}`
}

export const Pagination = memo(
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  ({ leftCount, rightCount, totalCount, leftArrowAction, rightArrowAction, className }) => {
    const [isHideLeftArrow, setIsHideLeftArrow] = useState(null)
    const [isHideRightArrow, setIsHideRightArrow] = useState(null)
    const [paginationScore, setPaginationScore] = useState(null)

    useEffect(() => {
      const paginationScore = getPaginationScore(leftCount, rightCount, totalCount)
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setIsHideLeftArrow(leftCount + 1 <= 1)
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setIsHideRightArrow(rightCount >= totalCount)
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setPaginationScore(paginationScore)
    }, [leftCount, rightCount, totalCount])

    return (
      <div
        className={classNames('pagination-container', {
          [className]: Boolean(className),
          'hide-pagination-actions': isHideLeftArrow && isHideRightArrow,
        })}>
        <div className='pagination-counter'>
          <span>{paginationScore}</span>
        </div>
        <div className='pagination-actions'>
          <SvgIcon
            className={classNames('pagination-icon-left', {
              'pagination-icon-hidden': isHideLeftArrow,
            })}
            name='chevronDown'
            onClick={leftArrowAction}
          />
          <SvgIcon
            className={classNames('pagination-icon-right', {
              'pagination-icon-hidden': isHideRightArrow,
            })}
            name='chevronDown'
            onClick={rightArrowAction}
          />
        </div>
      </div>
    )
  },
)
